import api from './api';

export const getEventsByParcelCode = (parcelCode: string) => {
  return api.get({
    path: `/parcels/${parcelCode}/parcelevents`,
  });
};
